<template>
    <div>
      <h2>관리자권한 / 강사권한</h2>
      <p>
        Tens에듀는 관리자와 강사의 2가지 권한이 있습니다.<br/>
        별도의 설정이 없이, 학원에 처음에 발급된 ID/PW는 관리자 권하이며, Tens에듀에서 추가로 추가한 직원은 모두 강사의 권한입니다.<br/>
        이때, 강사 권한의 기본 권한은 조정이 가능하며, 특정한 개인에게 권한이 부여되면 이 경우는 강사의 기본 권한보다 우선으로 설정됩니다.<br/>
      </p>
      
      <section>
        <div class="p-relative section_0" id="admin_permission">
            <div class="ft-b">1)    관리자 권한</div>
            
            <div class="p-relative section_1">
                -   Tens에듀의 전체 메뉴를 이용할 수 있습니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/setting/setting_permission_admin.jpg" /></div>
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="teacher_permission">
            <div class="ft-b">2)    강사 권한</div>
            
            <div class="p-relative section_1">
                -   Tens에듀의 메뉴에서 홈화면 / 반관리 / 수업관리 / 메시지관리가 나타납니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/setting/setting_permission_teacher.jpg" /></div>
            </div>
            <div class="p-relative section_1">
                -   이 경우는 초기 설정된 것이며, 권한 설정에서 변경할 수 있습니다.
            </div>
            <div class="p-relative section_1">
                -   권한이 설정되면, 권한에 맞게 메뉴가 변동합니다.
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="permission_teacher_setting">
            <div class="ft-b">3)    기본권한설정</div>
            
            <div class="p-relative section_1">
                -   관리자 권한은 수정할 수 없으며, 권리자를 추가할 수도 없습니다.
            </div>
            <div class="p-relative section_1">
                -   기본권한은 모든 강사권한으로 설정합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/setting/permission_teacher_setting.jpg" /></div>
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="permission_personal_setting">
            <div class="ft-b">4)    개별권한설정</div>
            
            <div class="p-relative section_1">
                -   개별권한은 기본권한보다 우선됩니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/setting/permission_personal_setting.jpg" /></div>
            </div>
        </div>

      </section>

      <q-drawer show-if-above side="right" class="bg-white">
          <q-list>
            <q-item-label header style="padding:40px 42px 20px;">바로가기</q-item-label>
            <li class="q-px-lg pointer" 
                      v-for="m in menuItems" 
                      :key="m.label"
                      @click="goTo(m.link)" >
                {{m.label}}
            </li>
            
          </q-list>
      </q-drawer>
    </div>
</template>

<script>
import goto from "./goto.js";
export default {
    components : {
    },
    data : function() {
        return {
            menuItems: [
                { label: '관리자 권한', link: '#admin_permission' },
                { label: '강사 권한', link: '#teacher_permission' },
                { label: '기본권한 설정', link: '#permission_teacher_setting' },
                { label: '개별권한 설정', link: '#permission_personal_setting' },
            ]
        }
    },
    computed :{
    },
    methods : {
        goTo(link) {
            goto.goto_link(link);
        }
    },
    beforeMount() {
        goto.clear();
    }
}
</script>


